import {
  BottomSheetComponent,
  Modal,
  ParamListBase,
  registerBottomSheets,
  registerNavigationHandlers,
} from '@bonanza-social/navigation';

import QuitRegistrationBottomSheet from './bottomSheets/QuitRegistrationBottomSheet/QuitRegistrationBottomSheet';
import DuplicateAccountsBottomSheet from './bottomSheets/DuplicateAccountsBottomSheet/DuplicateAccountsBottomSheet';
import MaxDuplicatesReachedBottomSheet from './bottomSheets/MaxDuplicatesReachedBottomSheet/MaxDuplicatesReachedBottomSheet';

const bottomSheets = {
  QuitRegistrationBottomSheet,
  DuplicateAccountsBottomSheet,
  MaxDuplicatesReachedBottomSheet: MaxDuplicatesReachedBottomSheet,
};

registerNavigationHandlers<AppNavigatorParamsList, 'RAFTerms'>({
  RAFTerms() {
    Modal.open({ namespace: 'registration', type: 'RAFTerms' });
  },
});

registerBottomSheets('registration', bottomSheets);

declare global {
  interface AuthNavigatorParamsList extends ParamListBase {
    RAFTerms: undefined;
  }
}

declare global {
  interface RegisteredBottomSheets {
    registration: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}
